export default [
  {
    path: '/grippers',
    name: 'grippers',
    component: () => import('@/views/grippers/GrippersMain.vue'),
  },
  {
    path: '/grippers/create',
    name: 'grippers-create',
    component: () => import('@/views/grippers/GrippersCreate.vue'),
    meta: {transitionName: 'zoom'},
  },
  {
    path: '/grippers/edit/:id',
    name: 'grippers-edit',
    component: () => import('@/views/grippers/GrippersEdit.vue'),
    meta: {transitionName: 'slide'},
  },
];
